const { language } = window['tums-components'].default.Utils;
const { registerLanguage: rl } = language;
rl(require('@/language/wlanPlannerError').default); // 注册

export const URI = '/tums';
export const VERSION = 'v1';
export const MODELNAME = 'wlanPlanner';

export const packageUrl = (method:string, submodule:string, model:string = MODELNAME, v:string = VERSION) : string => {
    return `${URI}/${model}/${v}/${submodule}/${method}`;
};

export const packageNoSubmoduleUrl = (method:string, model:string = MODELNAME, v:string = VERSION) : string => {
    return `${URI}/${model}/${v}/${method}`;
};

export interface rspFields{
    // eslint-disable-next-line camelcase
    error_code:string,
    msg:string,
    result:any
}
